<template>
  <pswp-element name="item" />
</template>

<script>
import PswpElement from './element.vue';

export default {
  components: { PswpElement },
};
</script>
